<!-- Sidebar header -->
<div class="sidebar-section bg-black bg-opacity-10 border-bottom border-bottom-white border-opacity-10 d-md-none">
  <div class="sidebar-logo d-flex justify-content-center align-items-center">
    <a class="d-inline-flex align-items-center py-2 ms-2">
      <img [src]="'logo/logo-admin-chatnhanh.svg' | imgCdn" class="sidebar-logo-icon"
           alt="Logo" width="25px">
    </a>
    <div class="sidebar-resize-hide ms-auto me-2">
      <button type="button" class="btn btn-flat-white btn-icon btn-sm rounded-pill border-transparent d-lg-none"
              (click)="appLayout.isOpenNavMobile = !appLayout.isOpenNavMobile">
        <i class="ph ph-x"></i>
      </button>
    </div>
  </div>
</div>
<!-- /sidebar header -->

<!-- Sidebar content -->
<div class="sidebar-content">
  <!-- Main navigation -->
  <div class="sidebar-section">
    <ul class="nav nav-vertical nav-sidebar" data-nav-type="accordion">
      @for (item of navItems; track item.path) {
        <li class="nav-item" [class.nav-item-submenu]="item.children && item.children.length > 0"
            [class.nav-item-open]="!!item.active && !isLoader">

          <!-- Menu cấp 1 -->
          @if (item.children && item.children.length > 0) {
            <!-- Menu có menu con -->
            <a class="nav-link align-items-center cursor-pointer {{ item.active ? 'active' : '' }}"
               (click)="item.active = !item.active">
              @if (item.icon) {
                <i class="{{item.icon}} fs-6"></i>
              }
              <span>{{ item.originTitle ? item.originTitle : item.title | transloco }}</span>
            </a>
            <!-- Menu con của cấp 1 -->
            @if (item.children && item.children.length > 0) {
              <ul class="nav-group-sub posColl {{ item.active && !isLoader ? 'show' : '' }}">
                @for (subItem of item.children; track subItem.path) {
                  @if (subItem.title || subItem.originTitle) {
                    <li class="nav-item" [class.nav-item-submenu]="subItem.children && subItem.children.length > 0"
                        [class.nav-item-open]="!!subItem.active && !isLoader">

                      <!-- Menu cấp 2 -->
                      @if (subItem.children && subItem.children.length > 0) {
                        <!-- Menu có menu con -->
                        <a class="nav-link align-items-center cursor-pointer {{ subItem.active ? 'active' : '' }}"
                           (click)="subItem.active = !subItem.active">
                          @if (subItem.icon) {
                            <i class="{{subItem.icon}} fs-6"></i>
                          }
                          <span>{{ subItem.originTitle ? subItem.originTitle : subItem.title | transloco }}</span>
                          @if (subItem.isNewFeature) {
                            <span class="badge bg-warning text-white ms-1">New</span>
                          }
                        </a>
                        <!-- Menu con của cấp 2 -->
                        @if (subItem.children && subItem.children.length > 0) {
                          <ul class="nav-group-sub posColl {{ subItem.active && !isLoader ? 'show' : '' }}">
                            @for (childItem of subItem.children; track childItem.path) {
                              @if (childItem.title || childItem.originTitle) {
                                <li class="nav-item"
                                    [class.nav-item-submenu]="childItem.children && childItem.children.length > 0"
                                    [class.nav-item-open]="!!childItem.active && !isLoader">

                                  <!-- Menu cấp 3 -->
                                  @if (childItem.children && childItem.children.length > 0) {
                                    <!-- Menu có menu con -->
                                    <a
                                      class="nav-link align-items-center cursor-pointer {{ childItem.active ? 'active' : '' }}"
                                      (click)="childItem.active = !childItem.active">
                                      @if (childItem.icon) {
                                        <i class="{{childItem.icon}} fs-6"></i>
                                      }
                                      <span>{{ childItem.originTitle ? childItem.originTitle : childItem.title | transloco }}</span>
                                    </a>

                                    <!-- Menu con của cấp 3 -->
                                    <ul class="nav-group-sub posColl {{ childItem.active && !isLoader ? 'show' : '' }}">
                                      @for (grandChildItem of childItem.children; track grandChildItem.path) {
                                        @if (grandChildItem.title || grandChildItem.originTitle) {
                                          <li class="nav-item">
                                            <a
                                              class="nav-link align-items-center cursor-pointer {{ grandChildItem.active ? 'active' : '' }}"
                                              [routerLink]="grandChildItem.url"
                                              (click)="onHandleClick(grandChildItem.url)">
                                              @if (grandChildItem.icon) {
                                                <i class="{{grandChildItem.icon}} fs-6"></i>
                                              }
                                              <span>{{
                                                  grandChildItem.originTitle ? grandChildItem.originTitle : grandChildItem.title |
                                                    transloco
                                                }}</span>
                                            </a>
                                          </li>
                                        }
                                      }
                                    </ul>
                                  } @else {
                                    <!-- Menu không có menu con -->
                                    <a
                                      class="nav-link align-items-center cursor-pointer {{ childItem.active ? 'active' : '' }}"
                                      [routerLink]="childItem.url" (click)="onHandleClick(childItem.url)">
                                      @if (childItem.icon) {
                                        <i class="{{childItem.icon}} fs-6"></i>
                                      }
                                      <span>{{ childItem.originTitle ? childItem.originTitle : childItem.title | transloco }}</span>
                                    </a>
                                  }
                                </li>
                              }
                            }
                          </ul>
                        }
                      } @else {
                        <!-- Menu không có menu con -->
                        <a class="nav-link align-items-center cursor-pointer {{ subItem.active ? 'active' : '' }}"
                           [routerLink]="subItem.url" (click)="onHandleClick(subItem.url)">
                          @if (subItem.icon) {
                            <i class="{{subItem.icon}} fs-6"></i>
                          }
                          <span>{{ subItem.originTitle ? subItem.originTitle : subItem.title | transloco }}</span>
                          @if (subItem.isNewFeature) {
                            <span class="badge bg-warning text-white ms-1">New</span>
                          }
                        </a>
                      }
                    </li>
                  }
                }
              </ul>
            }
          } @else {
            <!-- Menu không có menu con -->
            <a class="nav-link align-items-center cursor-pointer {{ item.active ? 'active' : '' }}"
               [routerLink]="item.url"
               (click)="onHandleClick(item.url)">
              @if (item.icon) {
                <i class="{{item.icon}} fs-6"></i>
              }
              <span>{{ item.originTitle ? item.originTitle : item.title | transloco }}</span>
              @if (item.path === 'conversation' && unreadConvCount > 0) {
                <span class="badge bg-danger rounded-pill ms-auto">{{ unreadConvCount }}</span>
              }
            </a>
          }

        </li>
      }
    </ul>
  </div>
  <!-- /main navigation -->
</div>
<!-- /sidebar content -->
